<template>
  <div v-if="false" id="top-left-border" />
  <div id="bottom-right-border" />

  <main>
    <el-menu
      :default-active="2"
      mode="horizontal"
      background-color="#ffffff"
      text-color="#0a0a0a"
      active-text-color="#0a0a0a"
      router="true"
      @select="handleNavSelect"
      class="top-nav"
    >
      <el-menu-item class="navbar-brand" index="1">
        <router-link to="/">
          <img src="./assets/Logo2.png" width="36" height="36" alt="Xster" />
        </router-link>
      </el-menu-item>
      <el-menu-item index="2" route="/">
        <span class="nav-text">Realm</span>
      </el-menu-item>

      <el-sub-menu index="3">
        <template #title> <span class="nav-text">Workspace</span> </template>
        <el-menu-item index="3-1" route="/work"> Discover </el-menu-item>
        <el-menu-item index="3-2" route="/colors"> Colors </el-menu-item>
        <el-menu-item index="3-3" route="/chromosome"> Chromosome </el-menu-item>
        <el-menu-item index="3-4" route="/excelfaker"> Excel Faker </el-menu-item>
        <el-menu-item index="3-5" route="/hiit"> HIIT </el-menu-item>
      </el-sub-menu>
      <el-menu-item index="4" route="/about">
        <span class="nav-text">About</span>
      </el-menu-item>
      <el-menu-item index="5" route="/contact">
        <span class="nav-text">Contact</span>
      </el-menu-item>
    </el-menu>

    <router-view></router-view>
  </main>

  <my-footer />
</template>

<script>
// import HomePage from './components/home/HomePage.vue'
import request from "@/utils/request";

export default {
  name: "App",
  mounted: function () {
    // Check for JWT token in localStorage
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      request({
        method: "get",
        url: "/sign",
        params: { data: navigator.userAgent },
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data) {
              localStorage.setItem("jwtToken", response.data);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching initial data:", error);
        });
    }
  },
  components: {
    // HomePage
  },
  methods: {
    handleNavSelect: function (key, keyPath) {
      console.log("handleNavSelect");
      console.log(key, keyPath);
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  color: #0a0a0a;
  background-color: #ffffff;
  font-family: "Inter", "PingFang SC", "Noto Sans SC", -apple-system,
    BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-feature-settings: "cv11", "ss01";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

#sketch-holder {
  display: none;
}

.nav-text {
  font-size: 0.95rem;
  text-decoration: none;
  font-weight: 500;
  letter-spacing: -0.01em;
}

main {
  width: 100vw;
  flex: 1;
  z-index: 3;
  position: relative;
}

#top-left-border,
#bottom-right-border {
  display: none;
}

.top-nav {
  border-bottom: 1px solid #eaeaea !important;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.top-nav.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #0a0a0a !important;
}
</style>
